import { MsaasJobListing } from '~/types/hlx/msaasJobListing';
import { COMPENSATION_TYPE_OPTIONS } from './constants';
import { CompensationFormValues } from './types';

export const transformApiToCompensationForm = (
  msaasListing: MsaasJobListing
): CompensationFormValues => {
  return {
    id: msaasListing.detail?.id,
    msaasListingId: msaasListing.id,
    compType:
      COMPENSATION_TYPE_OPTIONS.find((option) => option.value === msaasListing.detail?.compType) ||
      COMPENSATION_TYPE_OPTIONS[0],
    pricePerHour: msaasListing.detail?.pricePerHour ?? null,
    pricePerShift: msaasListing.detail?.pricePerShift ?? null,
    pricePerRvu: msaasListing.detail?.pricePerRvu ?? null,
    yearlyRvusPerFte: msaasListing.detail?.yearlyRvusPerFte ?? null,
  };
};

export const transformCompensationFormToApi = (formValues: CompensationFormValues) => {
  const {
    compType,
    id,
    msaasListingId,
    pricePerHour,
    pricePerShift,
    pricePerRvu,
    yearlyRvusPerFte,
  } = formValues;

  // Build base payload (always included)
  const basePayload = {
    id,
    msaasListingId,
    compType: compType.value,
  };

  // Only include the relevant compensation field based on compType
  switch (compType.value) {
    case 'HOUR':
      return JSON.stringify({
        ...basePayload,
        pricePerHour,
      });
    case 'SHIFT':
      return JSON.stringify({
        ...basePayload,
        pricePerShift,
      });
    case 'RVU':
      return JSON.stringify({
        ...basePayload,
        pricePerRvu,
        yearlyRvusPerFte,
      });
    default:
      return JSON.stringify(basePayload);
  }
};
